export default "__VITE_ASSET__BxhHvPU6__"